import { CloseOutlined, UploadOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import type { NUserProfile } from '@pages/Users/UserProfile/UserProfile.types';

import type { MenuProps } from 'antd';

export const AvatarDropdownItems: NUserProfile.DropdownConstructor = ({
  uploadAvatar,
  deleteAvatar,
  Photo,
}) => {
  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div onClick={deleteAvatar} className="unselectable">
          <CloseOutlined style={{ marginRight: '10px' }} />
          Удалить фото
        </div>
      ),
    },
    {
      key: '2',
      label: (
        <div
          onClick={() => document.getElementById('PhotoInput')?.click()}
          className="unselectable"
        >
          <UploadOutlined style={{ marginRight: '10px' }} />
          Установить фото
          <Input
            type="file"
            style={{ display: 'none' }}
            id="PhotoInput"
            onChange={uploadAvatar}
          />
        </div>
      ),
    },
  ];

  if (!Photo) {
    items.shift();
  }

  return items;
};
